<template>


   

        <div class="dashboard-wrapper">

            <div v-if="ADMIN_SIGNIN_RES">
                <div class="system-dash-wrapper">
                    
                    <cSysBookingNo v-if="sysBookingNum" :sysBookingNum="sysBookingNum" :prgrsBarData="dayToDaySalesRes"></cSysBookingNo>
                    <div class="row">
                        <div class="col-md-3">
                            <cSysTotalBookings v-if="sysBookingNum" :sysBookingNum="sysBookingNum" ></cSysTotalBookings>



                        </div> 
                        <div class="col-md-6">
                            <cSysWeeklySale></cSysWeeklySale>

                        </div>
                        <div class="col-md-3">
                            <cSysSearchCount></cSysSearchCount>
                            <cSysUserLoginActivity></cSysUserLoginActivity>

                            <!-- <div class="user-wrap">
                           <div class="card">
                                    <div class="card-body"><h4 class="card-title m-b-0 title-font">Searchs Today</h4>
                                        <h2 class="font-light">35,658 <span class="font-16 text-success font-medium">+23%</span>
                                        </h2>
                                        <div class="m-t-30">
                                            <div class="row text-center">
                                                <div class="col-6 border-right"><h4 class="m-b-0">58%</h4><span
                                                        class="font-14 text-muted">New Users</span></div>
                                                <div class="col-6"><h4 class="m-b-0">42%</h4><span
                                                        class="font-14 text-muted">Repeat Users</span></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div> -->
                        </div>
                        <div class="col-md-6">
                            <cSysAgentSales></cSysAgentSales>

                        </div>
                        <div class="col-md-6">
                            <cSysDayToDaySales v-if="dayToDaySalesRes && sysBookingNum" :sysBookingNum="sysBookingNum" :dayToDaySalesRes="dayToDaySalesRes"></cSysDayToDaySales>

                        </div>
                    </div>



                    <!-- <cSysTodaySales></cSysTodaySales> -->

                    <!-- {{dayToDaySalesRes}} -->


                </div>
            </div>

            <!-- <cDPtopCards></cDPtopCards>
            <div class="search-w">
                <div v-if="GET_SIGNIN_RES" class="search-dash-option ">
                    <cSearch v-if="isShowState"
                             :searchObject="search"
                             v-on:send="navToResultPage"

                    />
                   
                </div>
            </div>


            <div class="table-list">
                <cDPminiTkt></cDPminiTkt>

                <cDPminiBookingList></cDPminiBookingList>

    </div> -->
        </div>
</template>
<script>
    

    import BaseConfiguration from "../../../config/base";
    import cSysAgentSales from "../../../components/dashboard/system/cSysAgentSales";
    import cSysBookingNo from "../../../components/dashboard/system/cSysBookingNo";
    import cSysSearchCount from "../../../components/dashboard/system/cSysSearchCount";
    import cSysUserLoginActivity from "../../../components/dashboard/system/cSysUserLoginActivity";
    import cSysTotalBookings from "../../../components/dashboard/system/cSysTotalBookings";    
    import cSysWeeklySale from "../../../components/dashboard/system/cSysWeeklySale";
    import cSysTodaySales from "../../../components/dashboard/system/cSysTodaySales";
    import cSysDayToDaySales from "../../../components/dashboard/system/cSysDayToDaySales";

    import {VALIDATE_SUCCESS_RES, getErrorMessage} from "../../../util/apiValidate";
    import {mapActions, mapGetters} from "vuex";

    import {
        LOG_TYPE,
        FILE_NAME,
        HTTP_CODES,
        API_VALUES
    } from "../../../config/API_DATA";
    import Logger from "../../../services/logger";
    import apiDayToDaySales from "../../../services/apiDayToDaySales";
    import apiGetSysBookingNumber from "../../../services/apiGetSysBookingNumber";
    import Router from '../../../router'
    import {addClassToBody, removeClassBody} from "../../../util/util.js";
    import {PATHNAME, COMPONENT_NAME, TOAST_TYPE} from '../../../util/constants'
    import apiGetBalanceDetail from "../../../services/apiGetBalanceDetail";
    import {handleJWT, getErrorAlertValue} from "../../../util/util";
    import router, {navigate, goBack, updateCurrRouteQuery} from "../../../router/index";

    export default {
        name: 'Dashboard',
        components: {
            
            cSysAgentSales,
            cSysWeeklySale,
            cSysTodaySales,
            cSysBookingNo,
            cSysSearchCount,
            cSysUserLoginActivity,
            cSysDayToDaySales,
            cSysTotalBookings
        },
        data() {
            return {
               
               sysBookingNum : null,
                dayToDaySalesRes: null,
                

            }
        },
        methods: {


            ...mapActions("sDashBoard", {

                SET_AGENT_FINANCE_RESPONSE: "SET_AGENT_FINANCE_RESPONSE"
            }),
            ...mapActions("sCSearch", {
                SET_SEARCH_OBJ: "SET_SEARCH_OBJ",

            }),

            ...mapActions("sCMultiCitySearch", {
                SET_ML_SEARCH_OBJ: "SET_ML_SEARCH_OBJ",

            }),

            showAlert(val) {
                this.$emit("showAlert", val);
            },
            async getSysBookingNumber() {
                if (BaseConfiguration.isDebug) console.log("getSysBookingNumber");
                let returnValue;
                try {
                    let getBookingNumberReq = apiGetSysBookingNumber.buildRequest(); //constant

                    if (getBookingNumberReq != null) {
                        let getBookingNumberRes = await apiGetSysBookingNumber.getResponse(
                            getBookingNumberReq
                        );
                        if (VALIDATE_SUCCESS_RES(getBookingNumberRes)) {
                            returnValue = getBookingNumberRes.data.data;

                        } else {
                            let error = getErrorMessage(getBookingNumberRes);

                            let isJwt = handleJWT(error);
                            if (!isJwt) {
                                this.showAlert(getErrorAlertValue(error));
                            }
                        }
                    } else {
                        throw "invalid request";
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.C_SYS_BOOKING_NUMBER,
                        "error in  getSysBookingNumber",
                        err.toString(),
                        "getSysBookingNumber()",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return returnValue;
            },


            async getDayToDaySales() {
                let returnValue;
                try {
                    let dayToDaySalesReq = apiDayToDaySales.buildRequest();
                    if (dayToDaySalesReq) {
                        let dayToDaySalesRes = await apiDayToDaySales.getResponse(dayToDaySalesReq);
                        if (VALIDATE_SUCCESS_RES(dayToDaySalesRes)) {
                            returnValue = dayToDaySalesRes.data.data;

                        } else {
                            let error = getErrorMessage(dayToDaySalesRes);
                            let isJwt = handleJWT(error);
                            if (!isJwt) {
                                this.showAlert(getErrorAlertValue(error));
                            }
                        }
                    } else {
                        throw "invalid request";
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.DASHBOARD,
                        "error in  getDayToDaySales",
                        err.toString(),
                        " getDayToDaySales()",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return returnValue;
            },


        

        },


        computed: {
            ...mapGetters("sSysLogin", {
                ADMIN_SIGNIN_RES: "GET_ADMIN_SIGNIN_RES"
            }),
            ...mapGetters("sDashBoard", {
                userLogoDetail: "GET_AGENT_LOGO_DET_RES",
            }),
            ...mapGetters('sAgtLogin', {GET_SIGNIN_RES: 'GET_SIGNIN_RES'}),
            ...mapGetters("sDashBoard", {
                USER_ID: "GET_USER_ID"
            })

        },

        // beforeCreate() {
        //     addClassToBody(COMPONENT_NAME.DASHBOARD);
        // },

        // beforeDestroy() {
        //     removeClassBody();
        // },
        async created() {
            // if (BaseConfiguration.isDebug) console.log("created");
            try {

                this.$root.$emit("toggle-sidebar-minimize", true);


              
                if (this.ADMIN_SIGNIN_RES) {
                    this.dayToDaySalesRes = await this.getDayToDaySales();
                    this.sysBookingNum = await this.getSysBookingNumber();

                }

            } catch (err) {
                let body = Logger.buildRequest(
                    COMPONENT_NAME.C_SYS_DASHBOARD,
                    "error in created",
                    err.toString(),
                    "created",
                    LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
            }

        }

    }
</script>
<style>
    [v-cloak].c-sidebar c-sidebar-dark c-sidebar-show c-sidebar-fixed {
        display: none;
    }
</style>
